import { useWatch } from "react-hook-form";
import type { MediaSetting } from "@circle-react/types/MediaSetting";
import { MediaPreview } from "./MediaPreview";
import { MediaSettings } from "./MediaSettings";

interface EditTabProps {
  customThumbnailUrl: string | null;
  mediaSettings: MediaSetting;
  onCustomThumbnailUrlChange: (url: string | null) => void;
}

export const EditTab = ({
  customThumbnailUrl,
  mediaSettings,
  onCustomThumbnailUrlChange,
}: EditTabProps) => {
  const shouldMakeDownloadable = useWatch<MediaSetting, "make_downloadable">({
    name: "make_downloadable",
  });

  const mediaSettingsPreview: MediaSetting = {
    ...mediaSettings,
    custom_thumbnail_url: customThumbnailUrl,
    make_downloadable: shouldMakeDownloadable,
  };

  return (
    <div className="flex h-full">
      <div className="flex w-full flex-col md:w-96">
        <MediaSettings
          onCustomThumbnailUrlChange={onCustomThumbnailUrlChange}
        />
      </div>
      <div className="border-primary hidden flex-1 border-l p-8 md:flex">
        <MediaPreview mediaSettings={mediaSettingsPreview} />
      </div>
    </div>
  );
};
